// Confirmation only. Klaviyo records the email-link click; this page makes no writes.
(() => {
  const params = new URLSearchParams(window.location.search);
  let message = 'You’re all set.';
  if (params.get('ywr_pause') === 'timeline') {
    message = 'Done. We’ve paused the baby emails.';
  } else if (params.get('ywr_skip') === 'mothers_day') {
    message = 'Done. No Mother’s Day emails from us this year.';
  } else if (params.get('ywr_skip') === 'fathers_day') {
    message = 'Done. No Father’s Day emails from us this year.';
  }
  document.getElementById('paused-message').textContent = message;
})();
